import { render, staticRenderFns } from "./PedidoDetail.vue?vue&type=template&id=30ef9949&scoped=true&"
import script from "./PedidoDetail.vue?vue&type=script&lang=js&"
export * from "./PedidoDetail.vue?vue&type=script&lang=js&"
import style0 from "./PedidoDetail.vue?vue&type=style&index=0&id=30ef9949&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ef9949",
  null
  
)

export default component.exports